import { ROUTES } from '@/constants/routes'

export default function isQuestionnaireProgressComplete({ next, router, store }) {
    const { account, getWorkspaceSlug } = store

    if (account && !account.verification_questionnaire && !account.is_active) {
        return router.push({ name: ROUTES.questionnaire, params: { workspace: getWorkspaceSlug } })
    }

    next()
}
